<template>
	<div class="page pageContainer">

		<el-table :data="DataList.major" style="width: 100%;" row-key="id" border stripe
                  default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
              row-class-name="table-rowClass">
			<el-table-column type="index" label="序号" width="60">
			</el-table-column>
			<el-table-column prop="title" label="专业名称" min-width="200">
			</el-table-column>
			
			<el-table-column prop="null" v-for="(item,idx) in DataList.area " :key="idx" :label="item.area_name" min-width="80" v-if="item.children.length>0">
				<el-table-column prop="sort" v-for="(sitem,idx2) in item.children " :key="idx2" :label="sitem.area_name" min-width="80">
					<template slot-scope="scope">
						<div v-if="scope.row.node_type=='major'||!scope.row.children">


							<el-input @blur="saveData" placeholder="分数线" :autofocus="true" size="mini" v-if="area_id==scope.row.area[idx].children[idx2].id&&scope.row.id==major_id"
							 v-model="plan_num"></el-input>
							<span style="display: inline-block;width: 100%; cursor: pointer; height: 23px;" v-else @click="showInput(scope.row.id,scope.row.area[idx].children[idx2].id,scope.row.area[idx].children[idx2].plan)">{{scope.row.area[idx].children[idx2].plan.score_line}}</span>
						</div>
						<div v-else>
							<span v-if="scope.row.title=='合计'" style="font-weight: bold;">
								{{scope.row.area[idx].children[idx2].total}}
							</span>
						</div>



					</template>
				</el-table-column>
			</el-table-column>
			<el-table-column prop="null" v-else :label="item.area_name" min-width="80">
				<template slot-scope="scope">
					<div v-if="scope.row.node_type=='major'||!scope.row.children">
						<el-input @blur="saveData" placeholder="分数线" :autofocus="true" size="mini" v-if="area_id==scope.row.area[idx].id&&scope.row.id==major_id"
						 v-model="plan_num"></el-input>
						<span style="display: inline-block;width: 100%; height: 28px; cursor: pointer;" v-else @click="showInput(scope.row.id,scope.row.area[idx].id,scope.row.area[idx].plan)">{{scope.row.area[idx].plan.score_line}}</span>
					</div>

				</template>
			</el-table-column>




		</el-table>

		<div v-if="false" style="height: 50px;"></div>

	</div>
</template>

<script>
	export default {

		data() {
			return {

				DataList: {
					major: [],
					area: []
				},
				AreaList: [],
				area_id: 0,
				major_id: 0,
				plan_num: '',
				plan: null



			}
		},

		mounted() {
			this.query();



		},
		methods: {


			query() {

				this.$http.post('/api/sch_area_major_plan', {}).then(res => {

					let DataList = res.data;
					let arealist = [];
					for (let item of res.data.area) {
						if (item.children.length == 0) {
							arealist.push(item);
						} else {
							for (let sitem of item.children) {
								arealist.push(sitem);
							}
						}
					}
					this.AreaList = arealist;
					
					
					this.DataList = DataList
					console.log(DataList)

				});
			},
			showInput(major_id, area_id, plan) {
				this.major_id = major_id;
				this.area_id = area_id;
				this.plan_num = plan.score_line
				this.plan = plan





			},
			saveData() {
				let data = {
					id: this.plan.id ? this.plan.id : 0,
					major_id: this.major_id,
					area_id: this.area_id,
					score_line: this.plan_num
				}
				console.log(data)
				if (this.plan_num >= 0) {
					this.$http.post('/api/sch_areaplan_score_edit', data).then(res => {
						this.$message({
							type: 'success',
							message: '保存成功'
						});
						this.query();
						this.major_id = 0;
						this.area_id = 0;
						this.plan_num = 0
						this.plan = null


					});
				}

			},



			saveArea() {


				if (!this.EditItem.plan_score) {
					this.$message({
						type: 'error',
						message: '请输入计划分数'
					});
					return
				}
				if (!this.EditItem.total_score) {
					this.$message({
						type: 'error',
						message: '请输入总分数'
					});
					return
				}
				if (!this.EditItem.score_line) {
					this.$message({
						type: 'error',
						message: '请输入分数线'
					});
					return
				}






				this.$http.post('/api/sch_areascore_edit', this.EditItem).then(res => {
					this.$message({
						type: 'success',
						message: '保存成功'
					});
					this.query();
					this.dialogVisible = false


				});
			},


		}
	}
</script>
<style type="text/less" lang="less">
    .table-rowClass{
        td{
            padding: 0!important;
        }
    }
</style>
<style scoped>
	.custom-tree-node {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding-right: 8px;
	}
</style>
